<style lang="scss">
</style>

<template>
    <div class="search-wrap">
        <aside class='search-btn'>
            <ButtonGroup>
                <Button size='large' v-for="(item,index) in btnsearch" :key="index" :type="formData.EQ_status===item.value?'primary':'default'" @click="handleBtn('EQ_status',item.value)">{{item.label}}</Button>
            </ButtonGroup>
        </aside>
        <article class="search-main clearfix">
            <div class="pull-left">
                <Button type="primary" @click="handleModal('add')" icon="md-add">{{$t('erp.product.new_add',{defaultValue:'添加'})}}</Button>
                <Button type="success" @click="handleModal('upload')">{{$t('global.common.import',{defaultValue:'导入'})}}</Button>
                <Dropdown trigger="click">
                    <Button>
                        {{$t('global.common.operates',{defaultValue:'更多操作'})}}<Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem @click.native="handleModal('exportdd')">{{$t('global.common.condition_export',{defaultValue:'查询条件导出'})}}</DropdownItem>
                        <DropdownItem @click.native="handleModal('active')">{{$t('fbb.accountmanage.muti_active', { defaultValue: '批量激活' })}}</DropdownItem>
                        <DropdownItem @click.native="handleModal('cancel')">{{$t('fbb.alloment.muti_cancel',{defaultValue:'批量取消'})}}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>

            <div class="pull-right">
                <Form :label-width="50" inline>
                    <FormItem :label="$t('erp.virtualstore.transferordernum',{defaultValue:'调拨单号'})">
                        <Input clearable v-model.trim="formData.CN_transferNo"/>
                    </FormItem>
                    <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                        <Select clearable v-model="formData.EQ_lineId" filterable>
                            <Option v-for="item in getNewProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('erp.virtualstore.actualoutwarehouse',{defaultValue:'实际出库仓库'})">
                    <Select clearable v-model="formData.EQ_orgWarehouseId" filterable>
                            <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="1">
                        <Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
                        <Button @click="reset" icon='md-refresh'>{{$t('erp.disturibution.reset_order',{defaultValue:'重置'})}}</Button>
                        <Button type="text" @click="isOpen=!isOpen">{{$t('global.common.searchs',{defaultValue:'更多搜索'})}}<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                    </FormItem>
                </Form>
            </div>
        </article>
        <transition name='slide-both'>
            <Form class="search-other" :label-width="80" inline v-show="isOpen">
                <FormItem :label="$t('erp.virtualstore.virtualoutware',{defaultValue:'虚拟出库仓'})">
                    <Select
                    clearable
                    v-model="formData.EQ_outWarehouseId"
                    filterable
                    @on-query-change="getOutVsList">
                       <Option v-for="item in outVslist" :value="item.id" :key="item.id">{{ item.warehouseTitle }}({{ item.ruleName }})</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('erp.virtualstore.virtualinware',{defaultValue:'虚拟入库仓'})">
                    <Select
                    clearable v-model="formData.EQ_inWarehouseId"
                    filterable
                    @on-query-change="getInVsList">
                       <Option v-for="item in inVslist" :value="item.id" :key="item.id">{{ item.warehouseTitle }}({{ item.ruleName }})</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('global.common.status',{defaultValue:'状态'})">
                    <Select clearable v-model="formData.EQ_status" >
                        <Option v-for="item in btnsearch" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <!-- <FormItem label='起至日期'>
                    <DatePicker  type="daterange" clearable v-model="formData.BT_createdAt" placement="bottom-start"></DatePicker>
                </FormItem> -->
                <FormItem :label="$t('fbb.adjustment.created_name',{defaultValue:'创建人'})">
                    <Input clearable v-model.trim="formData.CN_createdName" />
                </FormItem>

            </Form>
        </transition>

    </div>
</template>

<script>
import { HttpGroupRuleItem } from '@/service/boss/allot'
import { mapState ,mapGetters} from 'vuex'

export default {
    data() {
        return {
            isOpen: false,
            inVslist: [],
            outVslist: [],
            formData: {
                CN_transferNo: '',
                EQ_lineId: '',
                EQ_orgWarehouseId: '',
                EQ_inWarehouseId: '',
                EQ_outWarehouseId: '',
                CN_createdName: '',
                EQ_status: 'ACTIVATE',
            },
        };
    },
    mounted() {
        this.update();
        this.getVsGroups();
    },
    computed: {
        ...mapGetters('boss',['warehouses']),
        ...mapGetters('diction',['getNewProductList']),
        btnsearch(){
            return [{
                value: 'ACTIVATE',
                label: this.$t('erp.channel.active',{defaultValue:'激活'})
            }, {
                value: 'DRAFT',
                label: this.$t('fbb.alloment.draft',{defaultValue:'草稿'})
            }, {
                value: '',
                label: this.$t('bi.work.task_all',{defaultValue:'全部'})
            },]
        },
    },
    methods: {
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        handleBtn(key, val) {
            this.$set(this.formData, key, val);
            this.update();
        },
        update() {
            const formdata = { ...this.formData };
            //  createdAt = formdata.BT_createdAt;
            // if (createdAt) {
            //     formdata.BT_createdAt = createdAt[0] ? this.handleDateFormat(createdAt[0]) + '~' + this.handleDateFormat(createdAt[1]) : '';
            // }
            this.$emit('on-update', { search: formdata, page: 1 });
        },
        reset() {
            this.formData = {
                CN_transferNo: '',
                EQ_lineId: '',
                // EQ_createdBy: '',
                EQ_orgWarehouseId: '',
                EQ_inWarehouseId: '',
                EQ_outWarehouseId: '',
                CN_createdName: '',
                EQ_status: 'ACTIVATE',
            };
            this.$emit('on-update', {
                search: {
                    ...this.formData
                },
                page: 1
            });
        },
        getInVsList(query) {
            this.getVsGroups(query, 'inVslist');
        },
        getOutVsList(query) {
            this.getVsGroups(query, 'outVslist');
        },
        async getVsGroups(query = "", key) {
            // console.log(key)
            HttpGroupRuleItem({
                page: 1,
                rows: 50,
                sidx: 'id',
                sord: 'desc',
                search: {
                'EQ_stockVirtualGroupRuleEntity.stockVirtualGroupEntity.status': 'ACTIVATE',
                    'CN_stockVirtualGroupRuleEntity.name': query
                }
            }).then(res => {
                // console.log(key)
                if (!key) {
                    // console.log(res.data.content)
                    this["inVslist"] = this["outVslist"] = res.data.content;
                } else {
                    this[key] = res.data.content;
                }
            });
        },
    },
};
</script>
